import { FC } from 'react'
import { StyleSheet } from 'react-native'
import { useAppSelector } from '../../hooks/redux'
import { selectLicense } from '../../redux/reducers/license'
import AppBar from '../UI/AppBar'
import Clock from '../UI/Clock'
import PrimaryTitle from '../UI/PrimaryTitle'

const CustomerAppBar: FC = () => {
    const license = useAppSelector(selectLicense)

    if (!license) {
        return null
    }

    return (
        <AppBar>
            <Clock style={styles.clock} />
            <PrimaryTitle style={styles.title}>{license.name}</PrimaryTitle>
        </AppBar>
    )
}

const styles = StyleSheet.create({
    clock: {
        marginLeft: 16,
    },
    title: {
        textAlign: 'center',
        position: 'absolute',
        left: 0,
        right: 0,
    },
})

export default CustomerAppBar
